module.exports = __webpack_public_path__ + "static/media/plane1.930b6548.gif";